/**
 * 統一的 API 客戶端
 * 透過 transport strategy 在 mock 與真實 HTTP 後端之間切換
 */

import { HttpTransport } from './httpTransport'
import { MockTransport } from './mockTransport'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:5080'
const API_MODE = import.meta.env.VITE_API_MODE || 'mock'

const defaultTransport = API_MODE === 'http'
  ? new HttpTransport(API_BASE_URL)
  : new MockTransport()

export type { ApiError } from './transport'

export class ApiClient {
  constructor(private readonly transport = defaultTransport) {}

  async get<T>(endpoint: string, params?: Record<string, unknown>, options?: RequestInit): Promise<T> {
    return this.transport.request<T>({
      method: 'GET',
      endpoint,
      params,
      options,
    })
  }

  async post<T>(endpoint: string, data?: unknown, options?: RequestInit): Promise<T> {
    return this.transport.request<T>({
      method: 'POST',
      endpoint,
      data,
      options,
    })
  }

  async put<T>(endpoint: string, data?: unknown, options?: RequestInit): Promise<T> {
    return this.transport.request<T>({
      method: 'PUT',
      endpoint,
      data,
      options,
    })
  }

  async delete<T>(endpoint: string, options?: RequestInit): Promise<T> {
    return this.transport.request<T>({
      method: 'DELETE',
      endpoint,
      options,
    })
  }

  async patch<T>(endpoint: string, data?: unknown, options?: RequestInit): Promise<T> {
    return this.transport.request<T>({
      method: 'PATCH',
      endpoint,
      data,
      options,
    })
  }
}

export const apiClient = new ApiClient()
export const apiMode = API_MODE
